import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { MenuPlacement } from 'react-select/src/types';
import { useSelector } from 'react-redux';
import { lagerSelector } from 'store/lookups/selector';
import { MultiSelect } from 'formComponents/Select/MultiSelect';

interface LagerByIntNrProps {
    label: string;
    disabled: boolean;
    values: number[];
    menuPlacement?: MenuPlacement;
    allowEmpty?: boolean;
    renderLabel?: 'label' | 'placeholder' | 'no';
    onChange: (newValue: number[]) => void;
}

export const LagerByIntNrMultiple: React.FC<LagerByIntNrProps> = ({
    label,
    values,
    disabled,
    menuPlacement = 'bottom',
    allowEmpty = false,
    renderLabel = 'label',
    onChange,
}) => {
    const lager = useSelector(lagerSelector);

    const options = React.useMemo(() => {
        const o = lager
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((l) => ({
                value: l.intNr.toString(),
                label: l.name,
            }));

        if (allowEmpty) {
            o.push({ value: '', label: '' });
        }

        return o;
    }, [lager, allowEmpty]);

    const selectedOptions = React.useMemo(
        () => options.filter((option) => values.includes(parseInt(option.value, 10))),
        [options, values],
    );

    return (
        <>
            {renderLabel === 'label' && <Label>{label}</Label>}
            <MultiSelect
                name={label}
                isDisabled={disabled}
                isClearable={allowEmpty}
                value={selectedOptions}
                options={options}
                menuPlacement={menuPlacement}
                onChange={(newValues: ValueType<SelectOption, true>): void => {
                    onChange(((newValues || []) as SelectOption[]).map((option) => parseInt(option.value, 10)));
                }}
                placeholder={renderLabel === 'placeholder' ? label : ''}
            />
        </>
    );
};
